import { Avatar, Badge, Button, ConfigProvider } from 'antd';
import { CaretRight, Export, HeartStraight, Newspaper } from 'phosphor-react';
import React from 'react';
import VideoImg from '../../../assets/images/video-img.png';
import WebStyle from '../../../styles/style-web.json';
import TagCarousel from '../tagModules/TagCarousel';

function VideoInfo({
  category,
  categoryTagStyle = 'bg-yellow-2 text-n-1000',
  title,
  speakers,
  tags = [],
  description,
  responsive
}) {
  return (
    <ConfigProvider theme={WebStyle}>
      <section
        className={`video-info-section ${responsive ? 'responsive-view' : ' '}`}
      >
        <div>
          <img src={VideoImg} alt="video dummy img" />
        </div>

        <div className="container">
          <div className="video-info-wrapper">
            <div className="videoinfo-title">
              {category ? (
                <Badge className={`badge-xs  ${categoryTagStyle}`}>
                  {category}
                </Badge>
              ) : null}

              {title ? <div className="display-h4">{title}</div> : null}
            </div>
            <div className="video-button-wrapper">
              <Button
                className="b-0 bg-n-400 text-n-900 text-small videoaction"
                icon={<Export size={24} weight="light" />}
              >
                Share
              </Button>
              <Button
                className="b-0 bg-n-400 text-n-900 text-small videoaction"
                icon={<Newspaper size={24} weight="light" />}
              >
                Resources
              </Button>
              <Button
                className="b-0 bg-n-400 text-n-900 text-small videoaction"
                icon={<HeartStraight size={24} weight="light" />}
              >
                Donate
              </Button>
            </div>
            <div className="video-avatar-group">
              {speakers?.map((speaker) => (
                <div
                  key={speaker?.id}
                  className="item d-flex align-center gap-8 flex-shrink-0"
                >
                  <Avatar
                    className="overflow-hidden"
                    size="small"
                    src={speaker?.image}
                  />
                  <div className="text-small-bold">{`${speaker?.firstName} ${speaker?.lastName}`}</div>
                </div>
              ))}
            </div>

            {tags?.length > 0 ? (
              <div className="video-info-tags">
                <TagCarousel
                  className="text-small tag-s bg-n-400 b-0 text-n-900 mr-4"
                  data={tags}
                  icon={<CaretRight size={16} />}
                />
              </div>
            ) : null}
            {description ? <p className="paragraph">{description}</p> : null}
          </div>
        </div>
      </section>
    </ConfigProvider>
  );
}
export default VideoInfo;
